import React from 'react'
import { Alert, Button, Progress, Space, Typography } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons'
import { PollSetupRun, PollSetupStage } from '../types'

const { Title, Text } = Typography

function stageIcon(status: PollSetupStage['status']) {
  if (status === 'done') return <CheckCircleOutlined style={{ color: '#52c41a' }} />
  if (status === 'error') return <CloseCircleOutlined style={{ color: '#ff4d4f' }} />
  if (status === 'running') return <LoadingOutlined />
  return (
    <span
      style={{
        display: 'inline-block',
        width: 14,
        height: 14,
        border: '1px solid #d9d9d9',
        borderRadius: '50%',
      }}
    />
  )
}

interface PollSetupProgressProps {
  setup?: PollSetupRun | null
  stages: PollSetupStage[]
  onRetry?: () => void
  onEditAnswers?: () => void
  retrying?: boolean
}

export default function PollSetupProgress({
  setup,
  stages,
  onRetry,
  onEditAnswers,
  retrying,
}: PollSetupProgressProps) {
  const items = setup?.stages?.length ? setup.stages : stages
  const doneCount = items.filter(item => item.status === 'done').length
  const percent = items.length ? Math.round((doneCount / items.length) * 100) : 0
  const failed = setup?.status === 'error' || items.some(item => item.status === 'error')

  return (
    <div>
      <Title level={3}>Настраиваем систему</Title>
      <Text type="secondary">Это займёт несколько секунд</Text>
      <Progress
        percent={
          failed
            ? percent
            : Math.max(percent, items.some(i => i.status === 'running') ? percent + 5 : percent)
        }
        status={failed ? 'exception' : percent >= 100 ? 'success' : 'active'}
        style={{ margin: '16px 0 24px' }}
      />
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        {items.map(item => (
          <Space key={item.key}>
            {stageIcon(item.status)}
            <Text>{item.title}</Text>
            {item.error && <Text type="danger">{item.error}</Text>}
          </Space>
        ))}
      </Space>
      {failed && (
        <Alert
          type="error"
          showIcon
          style={{ marginTop: 24 }}
          message={setup?.error || 'Не удалось завершить настройку'}
          action={
            <Space>
              {onEditAnswers ? (
                <Button size="small" onClick={onEditAnswers} disabled={retrying}>
                  Изменить ответы
                </Button>
              ) : null}
              {onRetry ? (
                <Button size="small" onClick={onRetry} loading={retrying}>
                  Повторить
                </Button>
              ) : null}
            </Space>
          }
        />
      )}
    </div>
  )
}
